import { toast } from "sonner";
import { useAuthStore } from "@/modules/auth";
import { useChannel } from "@/modules/realtime";

export function ForceLogoutListener() {
  const userId = useAuthStore((s) => s.user?.id);
  const forceLogout = useAuthStore((s) => s.forceLogout);

  // A self-initiated password change bumps auth_version server-side and fires
  // these events at THIS session too — usually before the HTTP response lands.
  // The initiating flow (ClientEmailGate) sets suppressForceLogout and shows
  // its own sign-out prompt; yanking the session here would skip that prompt.
  const suppressed = () => useAuthStore.getState().suppressForceLogout;

  useChannel(userId ? `user.${userId}` : null, {
    "auth.force_logout": (payload: { reason?: string }) => {
      if (suppressed()) return;
      toast.error(`Session ended: ${payload?.reason ?? "force_logout"}. Please sign in again.`);
      forceLogout();
      window.location.assign("/login");
    },
    "auth.version_bumped": () => {
      if (suppressed()) return;
      // Token will be invalidated server-side; gracefully drop session.
      forceLogout();
      window.location.assign("/login");
    },
  });

  return null;
}
